// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1MP-J","content":"ManualTimeModal_content__1PMbK"};